import type { IxcRegistrationV1Name } from '@interxfi/types';

export function formatName(name: IxcRegistrationV1Name | undefined) {
  if (!name) {
    return '';
  }

  return [name.prefix, name.first, name.preferred ? `"${name.preferred}"` : '', name.middle, name.last, name.suffix].filter(Boolean).join(' ');
}
